<template>
  <div class="box">
    <a-carousel class="banner-box" >
      <template v-for="(item, index) in banners">
        <img loading="lazy" :src="apiUrl + '/images/' + item.url" :ref="(el) => setImageRef(el, index)" @load="onImageLoad(index)">
      </template>
    </a-carousel>
    <a-row justify="center">
      <!-- 模块1 -->
      <a-col :span="20">
        <!-- 标题 -->
        <div class="title">
          <p>
            <span>多元布局 全面发展</span>
            <span>ENTERPRISE LAYOUT</span>
          </p>
          <p>成立于2015年，已发展为多业务于一体的科技成长型企业集团</p>
        </div>
        <!-- 模块1内容 -->
        <div class="module1">
          <div class="module1-flex-7">
            <div class="hover-item" style="border-radius: 20px 0px 0px 20px;">
              <img src="../assets/img/home/home-icon-1.png" class="icon">
              <img src="../assets/img/home/home-icon-hover-1.png" class="icon-hover">
              <h2>互联金融</h2>
              <p>驱动互联金融服务</p>
              <p>助力金融机构可持续增长</p>
            </div>
          </div>
          <div class="module1-flex-7">
            <div class="hover-item">
              <img src="../assets/img/home/home-icon-2.png" class="icon">
              <img src="../assets/img/home/home-icon-hover-2.png" class="icon-hover">
              <h2>商业模型</h2>
              <p>基于千亿级数据</p>
              <p>建立商业模型</p>
            </div>
          </div>
          <div class="module1-flex-10">
            <div class="hover-item" style="border-radius:  0px 20px 0px 0px;margin-bottom: 10px;">
              <img src="../assets/img/home/home-icon-3.png" class="icon">
              <img src="../assets/img/home/home-icon-hover-3.png" class="icon-hover">
              <div>
                <h2 style="margin-top: 0;">大数据SaaS</h2>
                <p>AI招财店长门店智慧运营</p>
                <p>一站式智能SaaS解决方案</p>
              </div>
            </div>
            <div class="hover-item" style="border-radius:  0px 0px 20px 0px;">
              <img src="../assets/img/home/home-icon-4.png" class="icon">
              <img src="../assets/img/home/home-icon-hover-4.png" class="icon-hover">
              <div>
                <h2 style="margin-top: 0;">AI算力</h2>
                <p>规划5000P超大算力</p>
                <p>智算无限商业可能</p>
              </div>
            </div>
          </div>
        </div>
      </a-col>
      <!-- 模板2 -->
      <a-col :span="20">
        <!-- 标题 -->
        <div class="title">
          <p>
            <span>闭环生态系统，实现可持续的业务增长和创新发展</span>
            <span>ECOSYSTEM</span>
          </p>
          <p>以SaaS服务为基础,数据算力为支撑,商业模型为驱动</p>
        </div>
        <!-- 模块2内容 -->
        <div class="module2">
          <a-col :span="11" class="centent-l-box">
            <div class="centent-l">
              <img :src="apiUrl + '/images/' + businessList[0]?.url">
              <p>{{ businessList[0]?.title }}</p>
              <p v-html="businessList[0]?.describe"></p>
            </div>
            <Consult/>
          </a-col>
          <a-col :span="12" :offset="1" class="centent-r-box">
            <img :src="apiUrl + '/images/' + businessList[1]?.url" style="width: 100%;height: auto;">
            <p class="title">{{ businessList[2]?.title }}</p>
            <p v-html="businessList[1]?.describe" style="margin-bottom: 80px;"></p>
            <img :src="apiUrl + '/images/' + businessList[2]?.url" style="width: 100%;height: auto;">
            <p class="title">{{ businessList[2]?.title }}</p>
            <p v-html="businessList[2]?.describe"></p>
          </a-col>
        </div>
      </a-col>
      <!-- 背景模块 -->
      <a-col :span="24">
        <div class="bg-module">让科技 · 联结起美好生活</div>
      </a-col>
      <a-col :span="20">
        <!-- 标题 -->
        <div class="title">
          <p>
            <span>品牌咨询</span>
            <span>OFFICIALLY</span>
          </p>
          <p>以SaaS服务为基础,数据算力为支撑,商业模型为驱动</p>
        </div>
      </a-col>
    </a-row>
    <!-- 模板3 -->
    <News :news="news" style="margin-bottom: 150px;" />
    <Footer />
  </div>
</template>

<script lang="ts" setup>
import { useStore } from 'vuex';
import { ref, onMounted } from 'vue';
import Consult from '@/components/consult.vue';
import Footer from '@/components/footer.vue';
import News from '@/components/news.vue';
import axios from 'axios';
// @ts-ignore
import { apiUrl } from '@/assets/js/global'
// 获取 store 实例
const store = useStore();
// banner列表
const banners: any = ref([{
  "url": "p-1741314430184-490458.jpg",
  "title": "",
  "describe": ""
}])
// 新闻列表
const news = ref([])
// 生态系统列表
const businessList: any = ref([])
// 获取banner图
const getBanner = () => {
  axios.post(apiUrl + '/api/banners/list', {
    code: 'HOME'
  }).then((res: any) => {
    if (res.data?.result.length == 0) return;
    banners.value = res.data?.result[0].urls
  });
}
// 获取品牌咨询列表
const getNews = () => {
  axios.get(apiUrl + '/api/brand_consult/list',).then((res: any) => {
    news.value = res.data?.result;
    news.value.forEach((item: any) => {
      const [year, month, day] = item?.date.split('-');
      item.time = `${year}-${month}`;
      item.day = `${day}`;
    })
  });
}
// 获取生态系统列表
const getBusinessList = () => {
  axios.get(apiUrl + '/api/business/list',).then((res: any) => {
    businessList.value = res.data?.result;
  });
}
// 图片的 ref 数组
const imageRefs:any = ref([]);
// 设置图片的 ref
const setImageRef = (el:any, index:number) => {
  if (el) {
    imageRefs.value[index] = el;
  }
};
// 图片加载完成后的回调
const onImageLoad = (index:number) => {
  const img = imageRefs.value[index];
  if (img) {
    store.commit('setbannerHeight',img.height - 110);
    store.commit('setnavBgColor','rgb(0 0 0 / 0%)');
    
  }
};
onMounted(() => {
  
  window.scrollTo(0, 0);
  getBanner();
  getNews();
  getBusinessList()
});
</script>

<style lang="less" scoped>
.box {
  color: #454545;
  width: 100%;
  height: 100%;
  min-width: 1200px;
  .banner-box{
    width: 100%;aspect-ratio: 48 / 23; /* 或 2.09 */
  }

  .title {
    p:nth-child(1) {
      display: flex;
      justify-content: space-between;
      font-size: 32px;
      padding-top: 160px;

      span:last-child {
        color: #DBDBDB;
      }
    }

    p:nth-child(2) {
      font-size: 24px;
      padding: 24px 0 60px 0;
      margin: 0;
    }
  }

  .module1 {
    display: flex;

    .module1-flex-7 {
      flex: 7;
      padding-right: 10px;

      .hover-item {
        cursor: pointer;
        height: 520px;
        flex-direction: column;
      }
    }

    .module1-flex-10 {
      flex: 10;

      .hover-item {
        cursor: pointer;
        height: 256px;
      }

      img {
        margin-right: 60px;
      }
    }

    .icon {
      display: block;
    }

    .icon-hover {
      display: none;
    }

    .hover-item {
      transition: background-color 1s;
      /* 定义过渡效果，持续时间为1秒 */
      display: flex;
      align-items: center;
      justify-content: center;
      background: #F7F7F7;
      color: #000000;

      img {
        width: 64px;
        height: 60px;
      }

      h2 {
        font-size: 30px;
        margin: 32px 0;
        line-height: normal;
      }

      p {
        color: #454545;
        font-size: 22px;
        line-height: 36px;
        margin-bottom: 0;
        font-weight: 100;
      }
    }

    .hover-item:hover {
      background-color: #EA2709;
      color: #fff;

      .icon-hover {
        display: block;
      }

      .icon {
        display: none;
      }

      p {
        color: #fff;
      }
    }
  }

  .module2 {
    display: flex;
    margin-bottom: 160px;

    .centent-l-box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-right: 1%;

      

      .centent-l {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        p:first-of-type {
          font-size: 32px;
          margin-top: 38px;
          margin-bottom: 26px;
        }

        p:last-of-type {}
      }
    }

    .centent-r-box {
      padding-left: 1%;

      .title {
        font-size: 32px;
        margin-top: 38px;
        margin-bottom: 26px;
      }

    }

    img {
      width: 100%;
      height: auto;
      border-radius: 10px;
    }

    .centent {}
  }

  .bg-module {
    background-image: url(@/assets/img/home/home-bg.png);
    height: 430px;
    background-size: cover;
    /* 或者使用 100% 100% */
    background-position: center;
    /* 确保图片居中 */
    background-repeat: no-repeat;
    /* 防止图片重复 */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 72px;
    color: #fff;
  }
}
.placeholder {
  width: 100%;
  height: 100%;
  background-color: #f0f0f0; /* 占位符背景色 */
  border-radius: 8px; /* 圆角 */
  animation: pulse 5s infinite; /* 加载动画 */
}
</style>
